import { ArrowRight, FileX } from 'lucide-react'
import { Button } from '@/shared/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/shared/ui/dialog'

interface MissingAttachment {
  id: string
  name: string
  description?: string
}

interface MissingAttachmentsDialogProps {
  open: boolean
  onClose: () => void
  missingAttachments: MissingAttachment[]
  onGoToAttachments: () => void
}

export const MissingAttachmentsDialog = ({
  open,
  onClose,
  missingAttachments,
  onGoToAttachments
}: MissingAttachmentsDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-red-100">
              <FileX className="h-5 w-5 text-red-600" />
            </div>
            <div>
              <DialogTitle>Adjuntos Obligatorios Faltantes</DialogTitle>
              <DialogDescription className="mt-1">
                Faltan {missingAttachments.length} adjunto
                {missingAttachments.length !== 1 ? 's' : ''} obligatorio
                {missingAttachments.length !== 1 ? 's' : ''}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="py-4 space-y-4">
          <p className="text-sm text-muted-foreground">
            No se puede avanzar al siguiente estado porque los siguientes archivos son obligatorios:
          </p>

          <ul className="space-y-3 list-disc list-inside pl-8">
            {missingAttachments.map((attachment) => (
              <li key={attachment.id} className="text-sm text-foreground">
                <span className="font-medium">{attachment.name}</span>
                {attachment.description && (
                  <p className="text-xs text-muted-foreground ml-5 mt-0.5">
                    {attachment.description}
                  </p>
                )}
              </li>
            ))}
          </ul>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose}>
            Cerrar
          </Button>
          <Button onClick={onGoToAttachments} className="gap-2">
            Ir a Adjuntos
            <ArrowRight className="h-4 w-4" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
